import React from 'react';
import styled from 'styled-components';
import { Button, mainTheme } from '@plecto/ui';
import { Loader } from '../common/loaders/Loader';
import { useTranslation } from 'react-i18next';

const SlideInFooter = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 10px 20px;
	gap: 10px;
	border-top: 1px solid ${mainTheme.slideIn.border};
	background-color: ${mainTheme.slideIn.background};
	${Button.cssSelector} {
		flex: 1 auto;
	}
`;

export default function Footer({ onSave, onClose, isSaving, cancelText, saveText }) {
	const { t } = useTranslation();
	return <SlideInFooter className={'slide-in-footer'}>
		<Button onClick={onClose}>{cancelText || t('Cancel')}</Button>
		<Button variant={'primary'} onClick={onSave}>{isSaving ? <Loader /> : (saveText || t('Save'))}</Button>
	</SlideInFooter>;
}
